import { useTranslation } from "react-i18next"
import { useDownload } from "../../../../../../../../hooks/download/useDownload"
import { loogbookServiceFetch } from "../../../../../../../../utils/constants/callService"
import { returnQueryWithPagination } from "../../../../../../../../utils/methods/returnQuery"
import { TableActions } from "../../tableActions"
import { useLogbookContext } from "../../../../context"
import { Hashs } from "../../../activityRegister/utils"
import { formatUserMapFilter } from "../../../../utils"
import { useEffect, useState } from "react"
import { LinearProgressDownload } from "../linearProgressDownload"
import { UserSection } from "../../../../utils/enums/userSection"
import { SnackSimple } from "../../../../../../../../components"
import { Types } from "../../../../../../../../utils/enums"

export const MainActivityAction = () => {
    const { filter: { filterUser: { filter }, filterListUser, filterOneUser }, service: { getDetailInform, change }, state: { uuid, err, loading }, setVisibleUsersDataGeneralList } = useLogbookContext()
    const { t } = useTranslation()
    const query = `&view=users${returnQueryWithPagination({ filter: filter.filterString }, formatUserMapFilter)}`;
    const downloadCustome = () => {
        getDetailInform({ query: query, uuidTab: UserSection.MAIN_ACTIVITY })
    }
    const cleanFilterAll = () => {
        filter.cleanFilter()
        filterListUser.filter.cleanFilter()
        filterOneUser.filter.cleanFilter()
        setVisibleUsersDataGeneralList({})
    }
    const [openSnackbarErr, setOpenSnackbarErr] = useState({
        open: false,
        message: t('loogbook.titles.noActivity'),
        type: Types.ERROR,
    })

    const closeOpenSnakbarErr = () => {
        setOpenSnackbarErr((prev) => ({
            ...prev,
            open: false,
        }))
    }
    const {
        download,
        openSnackbar,
        downloadCSV,
        downloadPDF,
        downloadWORD,
        closeOpenSnakbar
    } = useDownload({
        query: query,
        docName: t('loogbook.activity'),
        downloadFuntion: loogbookServiceFetch.downloadLogbook,
    })

    useEffect(() => {
        if (uuid.MAIN_ACTIVITY) {
            const interval = setInterval(() => {
                getDetailInform({ query, uuidTab: UserSection.MAIN_ACTIVITY });
            }, 30000);
            return () => clearInterval(interval);
        }
    }, [uuid.MAIN_ACTIVITY])

    useEffect(() => {
        if (err.MAIN_ACTIVITY) {
            setOpenSnackbarErr((prev) => ({
                ...prev,
                open: true,
            }))
            change({uuidTab: UserSection.MAIN_ACTIVITY})
        }
    }, [err.MAIN_ACTIVITY])

    return (<>
        <LinearProgressDownload show={loading.MAIN_ACTIVITY} text={t('loogbook.generateDetailInform')} />
        <SnackSimple close={closeOpenSnakbarErr} open={openSnackbarErr.open} type={openSnackbarErr.type} message={openSnackbarErr.message} />
        <TableActions
            download={{
                csv: downloadCSV,
                pdf: downloadPDF,
                word: downloadWORD,
                disableCSV: download?.excel,
                disablePDF: download?.pdf,
                disableWORD: download?.word
            }}
            count={filter.counter}
            cleanActivityButton={{ onClick: cleanFilterAll }}
            downloadCustome={downloadCustome}
            downloadDisabled={{ 'pdf-detail': loading.MAIN_ACTIVITY, excel: false, pdf: false, word: false }}
            closeOpenSnakbar={closeOpenSnakbar}
            openSnackbar={openSnackbar}
            addActivityButton={{ onClick: () => { window.location.hash = Hashs.CREATE } }}
        />
    </>)
}